import { useMemo } from 'react';
import { useTranslation } from 'next-i18next';

export const useDealDetailsCMSData = () => {
  const { t } = useTranslation();

  const data = useMemo(
    () => ({
      data: {
        DealDetailsPage: {
          heroBackground: {
            sizes: {
              small_url: {
                url: '/imgs/Rebranding/petterns/asphalt_sm.png',
              },
              medium_url: {
                url: '/imgs/Rebranding/petterns/asphalt_sm.png',
              },
              large_url: {
                url: '/imgs/Rebranding/petterns/asphalt.png',
              },
            },
            alt: 'Asphalt background',
          },
          shareModalTitle: t('deal_details:share_deal'),
          aboutDealLabel: t('deal_details:about_deal'),
          bookBeforeLabel: t('deal_details:book_before'),
          pickUpBetweenLabel: t('deal_details:pick_up_between'),
          dropOffBetweenLabel: t('deal_details:dropoff_between'),
          minMotorcyclesLabel: t('deal_details:min_motorcycles'),
          maxMotorcyclesLabel: t('deal_details:max_motorcycles'),
          minRentalDaysLabel: t('deal_details:min_rental_days'),
          maxRentalDaysLabel: t('deal_details:max_rental_days'),
          dealValidSpecificModels: t('deal_details:deal_valid_specific_models'),
          dealValidAllModels: t('deal_details:deal_valid_all_models'),
          searchBy: t('deal_details:search_by'),
          dealsRemaining: t('deal_details:deals_remaining'),
          soldOut: t('deal_details:sold_out'),
          dealInsideApp: t('deal_details:deal_inside_app'),
          erLabel: t('deal_details:er_label'),
          exclusiveOfferLabel: t('deal_details:exclusive_offer'),
          termsConditionsLabel: t('deal_details:terms_conditions'),
          locationSearchInputPlaceholder: t('deal_details:search_by'),
          motorcycleRentalDealsTitle: t('deal_details:motorcycle_rental_deals'),
          viewRentalDealsBtnLabel: t('deal_details:view_rental_deals'),
          daysLabel: t('deal_details:days'),
          hoursLabel: t('deal_details:hours'),
          minutesLabel: t('deal_details:minutes'),
          secondsLabel: t('deal_details:seconds'),
          discountLabel: t('deal_details:discount'),
          youSaveLabel: t('deal_details:you_save'),
          perDay: t('deal_details:per_day'),
          harryRemainingDaysLabel: t('deal_details:remaining_days'),
          valueLabel: t('deal_details:value'),
          dealAvailbleMobilyOnlyTitle: t(
            'deal_details:deal_availble_mobily_only',
          ),
          downloadOnAppStoreAlt: t('deal_details:download_on_app_store_alt'),
          getItOnGooglePlayAlt: t('deal_details:get_it_on_google_play_alt'),
          qrCodeAlt: t('deal_details:qr_code_alt'),
          soldOutBtnLabel: t('deal_details:sold_out_btn_label'),
          searchNowBtnLabel: t('deal_details:search_now_btn_label'),
          oneWaySpecialForVehicle: t(
            'deal_details:one_way_special_for_vehicle',
          ),
          discountValue: t('deal_details:off'),
          vehicleOnlyLeft: t('deal_details:vehicle_only_left'),
          bookNowButtonLabel: t('deal_details:book_now'),
        },
        ShareLinkComponent: {
          shareText: t('common_share:share'),
          shareJourney: t('common_share:share_journey'),
          blueRidgeAdventure: t('common_share:blue_ridge_adventure'),
          copyLink: t('common_share:copy_link'),
          whatsApp: t('common_share:whats_app'),
          facebook: t('common_share:facebook'),
          email: t('common_share:email'),
          linkCopiedText: t('common_share:link_copied'),
        },
        ParticipatingLocationsComponent: {
          searchInputPlaceholder: t(
            'common_participating_locations:find_location_by_name',
          ),
          participatingLocationsTitle: t(
            'common_participating_locations:participating_locations',
          ),
          contactUsDialogTitle: t('common_participating_locations:contact_er'),
          showMapBtnText: t('common_participating_locations:show_map'),
          otherLocationsTitle: t(
            'common_participating_locations:other_locations',
          ),
          adressLabel: t('common_participating_locations:address'),
          callButtonLabel: t('common_participating_locations:call'),
          emailButtonLabel: t('common_participating_locations:email'),
          locationButtonLabel: t(
            'common_participating_locations:location_details',
          ),
        },
        DealCardComponent: {
          off: t('common_deal_card:off'),
          offAmount: t('common_deal_card:off_amount'),
          day: t('common_deal_card:day'),
          bego: t('common_deal_card:bego'),
          oneWaySpecial: t('common_deal_card:one_way_special'),
          buyOneDayGetOneLabel: t('common_deal_card:by_one_get_one'),
          buyXDaysGetYDaysFreeLabel: t('common_deal_card:buy_x_days_get_y_days_free'),
          dealDaySingular: t('common_deal_card:deal_day', { count: 1 }),
          dealDayPlural: t('common_deal_card:deal_day', { count: 2 }),
          learnMoreBtnLabel: t('common_deal_card:learn_more'),
        },
        TourBookingWidgetComponent: {
          startingAtText: t('common_tour_booking_widget:starting_at'),
          package: t('common_tour_booking_widget:package'),
          perPersonText: t('common_tour_booking_widget:per_person'),
          singularPersonText: t('common_tour_booking_widget:person.one'),
          pluralPersonsText: t('common_tour_booking_widget:person.many'),
          singularBikeText: t('common_tour_booking_widget:singular_bikes_text'),
          pluralBikesText: t('common_tour_booking_widget:multible_bikes_text'),
          singularRoomText: t('common_tour_booking_widget:singular_room'),
          prularRoomsText: t('common_tour_booking_widget:plural_room'),
          numberOfPackagesText: t('common_tour_booking_widget:packages'),
          bookBtnText: t('common_tour_booking_widget:book_button'),
          widgetNoteText: t('common_tour_booking_widget:widget_note'),
          offroadPackageText: t('common_tour_booking_widget:seater'),
          pluralOffRoadSingularSeatText: t('common_tour_booking_widget:seater'),
          timeSlotsText: t('common_tour_booking_widget:time_slots'),
          offroadNoOfPackagesText: t(
            'common_tour_booking_widget:offroad_no_of_packages',
          ),
          singularVehiclesText: t(
            'common_tour_booking_widget:vehicle_singular',
          ),
          pluralVehiclesText: t(
            'common_tour_booking_widget:vehicles_plural',
          ),
          pickTourLable: t('common_tour_booking_widget:pick_tour'),
          tourStartDateLabel: t('common_tour_booking_widget:tour_start_date'),
          minimumDeposit: t('common_tour_booking_widget:minimum_deposit'),
          selectTourPackage: t('common_tour_booking_widget:select_tour_package'),
          seaterLabel: t('common_tour_booking_widget:seater_other'),
          offroadPriceText: t('common_tour_booking_widget:offroad_price_text'),
        },
        NewMainWidgetComponent: {
          rentMotorcycle: t('common_new_main_widget:rent_motorcycle'),
          allMotorcycleTours: t('common_new_main_widget:all_motorcycle_tours'),
          guidedMotorcycleTours: t('common_new_main_widget:guided_motorcycle_tours'),
          selfDriveMotorcycleTours: t('common_new_main_widget:self_drive_motorcycle_tours'),
          returnToSameLocation: t('common_new_main_widget:return_to_same_location'),
          searchTour: t('common_new_main_widget:search_tour'),
          tourTypeLabel: t('common_new_main_widget:tour_type'),
          countryLabel: t('common_new_main_widget:country_label'),
          stateNameLabel: t('common_new_main_widget:state_name_label'),
          tourTabLabel: t('common_new_main_widget:tour_tab_label'),
          rentalTabLabel: t('common_new_main_widget:rental_tab_label'),
          country: t('common_new_main_widget:country'),
          stateName: t('common_new_main_widget:state_name'),
          futureBookings: t('common_new_main_widget:future_bookings'),
          saveEvenMore: t('common_new_main_widget:save_even_more'),
          rideRoundTripOrOneWay: t('common_new_main_widget:can_ride_rounded_trip_or_one_way'),
          startYourReservation: t('common_new_main_widget:start_your_reservation'),
          pickupLocation: t('common_new_main_widget:pickup_location'),
          choosePickupLocation: t('common_new_main_widget:choose_pickup_location'),
          dropoffLocation: t('common_new_main_widget:dropoff_location'),
          chooseDropoffLocation: t('common_new_main_widget:choose_dropoff_location'),
          sameAsPickupLocation: t('common_new_main_widget:same_as_pickup_location'),
          dropoffLocationError: t('common_new_main_widget:dropoff_location_error'),
          pickupDateLabel: t('common_new_main_widget:pickup_date_label'),
          dropoffDateLabel: t('common_new_main_widget:dropoff_date_label'),
          milesAway: t('common_new_main_widget:miles_away'),
          baseErrorHeader: t('common_new_main_widget:base_error_header'),
          warning: t('common_new_main_widget:warning'),
          warningNote: t('common_new_main_widget:warning_note'),
          saveUpTo: t('common_new_main_widget:save_up_to'),
          closedAlertText: t('common_new_main_widget:closed_alert'),
          timeLabel: t('common_new_main_widget:time'),
          reserveBtnLabel: t('common_new_main_widget:reserve'),
          vehiclesLabel: t('common_new_main_widget:vehicles'),
        },
      },
    }),
    [t],
  );

  return data;
};
